import React from 'react'
import PropTypes from 'prop-types'
import BEM from '@iui-kit/utils/bem'
import styles from './Button.css'

const bem = new BEM(styles)

const Button = ({
  className,
  children,
  size,
  theme,
  disabled,
  link,
  targetBlank,
  submit,
  ...otherProps
}) => {
  if (!link) {
    return (
      <button
        className={bem
          .b('button')
          .m(`${size}`, size)
          .m(`${theme}`, theme)
          .mix(className)
          .show()}
        disabled={disabled}
        type={submit ? 'submit' : 'button'}
        {...otherProps}
      >
        <span
          className={bem
            .b('button')
            .e('text')
            .show()}
        >
          {children}
        </span>
      </button>
    )
  }

  const target = targetBlank ? '_blank' : undefined
  return (
    <a
      href={link}
      className={bem
        .b('button')
        .m(`${size}`, size)
        .m(`${theme}`, theme)
        .m('disabled', disabled)
        .show()}
      target={target}
      {...otherProps}
    >
      <span
        className={bem
          .b('button')
          .e('text')
          .show()}
      >
        {children}
      </span>
    </a>
  )
}

Button.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  link: PropTypes.string,
  size: PropTypes.string,
  submit: PropTypes.bool,
  theme: PropTypes.string,
  targetBlank: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}

Button.defaultProps = {
  submit: false,
  link: null,
  targetBlank: false,
  disabled: false,
  theme: '',
  size: '',
  className: '',
  children: '',
  onClick: null
}

export default Button
